import React from 'react';
import PropTypes from 'prop-types';

const IconEvents = ({ width = 16, height = 16, viewBox = '0 0 16 16' }) => {
    return <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox={viewBox} fill='none'>
        <path d='M8.00008 11V13H6.00007V11H8.00008ZM8.00008 5V10H6.00007V5H8.00008ZM12.0001 2V0H10.0001V2H4.00007V0H2.00007V2H7.49627e-05V14.24C-0.00136589 14.3419 0.0179778 14.443 0.0569252 14.5372C0.0958725 14.6314 0.153606 14.7167 0.226601 14.7878C0.299597 14.8589 0.386322 14.9144 0.481482 14.9509C0.576642 14.9874 0.678241 15.0041 0.780075 15H13.2201C13.3219 15.0041 13.4235 14.9874 13.5187 14.9509C13.6138 14.9144 13.7006 14.8589 13.7735 14.7878C13.8465 14.7167 13.9043 14.6314 13.9432 14.5372C13.9822 14.443 14.0015 14.3419 14.0001 14.24V2H12.0001ZM13.0001 11.94V14H1.00007V4H13.0001V11.94Z' fill='#1F1F1F' />
    </svg>;
};

IconEvents.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    viewBox: PropTypes.string
};

export default IconEvents;
